import { scaleOrdinal } from 'd3-scale';
import { schemeCategory10 } from 'd3-scale-chromatic';

// TODO: We should probably be getting rid of this color scale and use the team's branding colors instead.
export const colorScaleFn = scaleOrdinal(schemeCategory10);
